const state = {
  projects: {},
  recentProjects: {},
  ActiveProjectModality: 0,
  currentProject: "",
  selectProfile: true,
  isSaldobrasata: false,
  isVerifica: false,
  isSelezione: false,
  selectionOutput: {},
  selectionResults: [],
  defValues: {},
  bloccaCalcolo: false
};

export default state;
